module.exports = __webpack_public_path__ + "img/Figma.19bc3917.svg";